// import React from 'react';
// import {
//   Box,
//   Typography,
//   TextField,
//   Grid,
//   FormControl,
//   Select,
//   MenuItem,
//   FormHelperText,
//   InputAdornment,
//   IconButton,
//   Dialog,
//   DialogContent,
//   Popper,
//   Grow,
//   Paper,
//   ClickAwayListener,
//   List,
//   ListItem,
//   ListItemText,
// } from '@mui/material';
// import CloudUpload from '@mui/icons-material/CloudUpload';
// import LinkIcon from '@mui/icons-material/Link';
// import CloseIcon from '@mui/icons-material/Close';

// const PropertyResidential = ({
//   residentialPropertyTypes,
//   setResidentialPropertyTypes,
//   selectedPropertyType,
//   setSelectedPropertyType,
//   propertyImages,
//   setPropertyImages,
//   imagePreviews,
//   setImagePreviews,
//   buildingName,
//   setBuildingName,
//   areaName,
//   setAreaName,
//   completeAddress,
//   setCompleteAddress,
//   propertyDescription,
//   setPropertyDescription,
//   socialMediaLink,
//   setSocialMediaLink,
//   selectedBHK,
//   setSelectedBHK,
//   selectedFurnish,
//   setSelectedFurnish,
//   bhkOptions,
//   furnishTypes,
//   carpetArea,
//   setCarpetArea,
//   carpetAreaUnits,
//   setCarpetAreaUnits,
//   builtUpArea,
//   setBuiltUpArea,
//   builtUpAreaUnits,
//   setBuiltUpAreaUnits,
//   uds,
//   setUds,
//   udsUnits,
//   setUdsUnits,
//   propertySize,
//   setPropertySize,
//   selectedUnit,
//   setSelectedUnit,
//   propertyLength,
//   setPropertyLength,
//   lengthUnit,
//   setLengthUnit,
//   propertyWidth,
//   setPropertyWidth,
//   widthUnit,
//   setWidthUnit,
//   zoneType,
//   setZoneType,
//   selectedOwnership,
//   setSelectedOwnership,
//   ownerships,
//   ownerName,
//   setOwnerName,
//   contactNumber,
//   setContactNumber,
//   emailAddress,
//   setEmailAddress,
//   profileData,
//   errors,
//   setErrors,
//   areaSuggestions,
//   setAreaSuggestions,
//   showAreaSuggestions,
//   setShowAreaSuggestions,
//   areaAnchorEl,
//   setAreaAnchorEl,
//   selectedAreaDetails,
//   setSelectedAreaDetails,
//   selectedImageIndex,
//   setSelectedImageIndex,
//   previewOpen,
//   setPreviewOpen,
//   validateAlphanumeric,
//   validateName,
//   validateNumber,
//   validateEmail,
//   validatePhone,
//   validateAlphanumericField,
//   validateSocialMediaLink,
//   location,
// }) => {
//   const selectedType = residentialPropertyTypes.find(type => type.id === selectedPropertyType);
//   const isPlot = selectedType?.id === 'plot';
//   const isAgricultureLand = selectedType?.id === 'agriculture-land';
//   const isFarmhouse = selectedType?.id === 'farm-house';
//   const isVilla = selectedType?.id === 'villa';
//   const isApartment = selectedType?.id === 'apartment';
//   const isIndependentHouse = selectedType?.id === 'independent-house';
//   const isPentHouse = selectedType?.id === 'pent-house';
//   const isStudio = selectedType?.id === 'studio';

//   const handlePropertyTypeSelect = (typeId) => {
//     setSelectedPropertyType(typeId);
//     const updatedTypes = residentialPropertyTypes.map(type => ({
//       ...type,
//       selected: type.id === typeId
//     }));
//     setResidentialPropertyTypes(updatedTypes);
//   };

//   const handleImageUpload = (event) => {
//     const files = event.target.files;
//     if (!files || files.length === 0) return;
//     if (files.length > 10) {
//       alert("You can only upload up to 10 images");
//       return;
//     }

//     const validFiles = Array.from(files).filter(file => file.type.startsWith('image/'));
//     if (validFiles.length !== files.length) {
//       alert("Only image files are allowed (JPEG, PNG, GIF, etc.)");
//       return;
//     }

//     const newPreviews = [];
//     const fileProcessPromises = validFiles.map(file => {
//       return new Promise((resolve) => {
//         const reader = new FileReader();
//         reader.onload = (e) => {
//           newPreviews.push(e.target.result);
//           resolve();
//         };
//         reader.onerror = () => {
//           console.error(`Failed to read file: ${file.name}`);
//           resolve();
//         };
//         reader.readAsDataURL(file);
//       });
//     });

//     Promise.all(fileProcessPromises).then(() => {
//       const updatedPreviews = [...imagePreviews, ...newPreviews];
//       const updatedFiles = [...propertyImages, ...validFiles];
//       setImagePreviews(updatedPreviews);
//       setPropertyImages(updatedFiles);
//       localStorage.setItem('propertyImagePreviews', JSON.stringify(updatedPreviews));
//     });
//   };

//   const handleAreaNameChange = (e) => {
//     const value = e.target.value;
//     setAreaName(value);
//     setAreaAnchorEl(e.currentTarget);
//     if (!value) {
//       setErrors(prev => ({...prev, areaName: 'Area Name is required'}));
//     } else if (value.trim().length < 1) {
//       setErrors(prev => ({...prev, areaName: 'Area Name must be at least 3 characters'}));
//     } else {
//       setErrors(prev => ({...prev, areaName: ''}));
//     }
//   };

//   const handleSelectArea = (area) => {
//     setAreaName(area.area);
//     setSelectedAreaDetails({
//       name: area.area,
//       address: area.address,
//       location: area.location
//     });
//     setAreaAnchorEl(null);
//     setShowAreaSuggestions(false);
//     setErrors(prev => ({...prev, areaName: ''}));
//   };

//   const handleAreaClickAway = () => {
//     setShowAreaSuggestions(false);
//   };

//   const fetchAreaSuggestions = async (query, city) => {
//     if (query.length < 1 || !city) return;
//     try {
//       const response = await fetch(`https://propertydealstalk.com/api/property/getAreasByCity?city=${encodeURIComponent(city)}&q=${encodeURIComponent(query)}`);
//       const data = await response.json();
//       if (data.success && data.areas && data.areas.length > 0) {
//         const transformedAreas = data.areas.map(area => ({
//           area: area.name,
//           address: area.address,
//           location: area.location
//         }));
//         setAreaSuggestions(transformedAreas);
//         setShowAreaSuggestions(true);
//       } else {
//         setAreaSuggestions([]);
//         setShowAreaSuggestions(false);
//       }
//     } catch (error) {
//       console.error('Error fetching area suggestions:', error);
//       setAreaSuggestions([]);
//       setShowAreaSuggestions(false);
//     }
//   };

//   React.useEffect(() => {
//     if (areaName.trim().length > 0 && location.state?.location) {
//       fetchAreaSuggestions(areaName, location.state.location);
//     } else {
//       setAreaSuggestions([]);
//       setShowAreaSuggestions(false);
//     }
//   }, [areaName, location.state?.location]);

//   return (
//     <Box>
//       {/* Property Type & Upload Images */}
//       <Grid container spacing={2} sx={{ mb: 3 }}>
//         <Grid item xs={12} sm="auto">
//           <Box sx={{ width: '410px', maxWidth: '100%' }}>
//             <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//               Property Type <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <FormControl fullWidth size="small">
//               <Select
//                 value={selectedPropertyType}
//                 onChange={(e) => handlePropertyTypeSelect(e.target.value)}
//                 displayEmpty
//                 sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                 renderValue={(selected) => {
//                   const selectedTypeObj = residentialPropertyTypes.find(type => type.id === selected);
//                   if (!selectedTypeObj) {
//                     return <em style={{ color: '#999' }}>Select Property Type</em>;
//                   }
//                   return (
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                       <Box component="img" src={selectedTypeObj.icon} alt={selectedTypeObj.name} sx={{ width: 20, height: 20, objectFit: 'contain' }} />
//                       <Typography sx={{ fontFamily: 'Outfit', fontSize: '13px' }}>
//                         {selectedTypeObj.name}
//                       </Typography>
//                     </Box>
//                   );
//                 }}
//               >
//                 {residentialPropertyTypes.map((type) => (
//                   <MenuItem key={type.id} value={type.id}>
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                       <Box component="img" src={type.icon} alt={type.name} sx={{ width: 20, height: 20, objectFit: 'contain' }} />
//                       {type.name}
//                     </Box>
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Box>
//         </Grid>

//         <Grid item xs={12} sm="auto">
//           <Box sx={{ width: '410px', maxWidth: '100%' }}>
//             <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//               Upload Images
//             </Typography>
//             <Box
//               sx={{
//                 height: 36,
//                 border: '2px dashed #d0d0d0',
//                 borderRadius: 1.5,
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 cursor: 'pointer',
//                 transition: 'all 0.2s ease',
//                 '&:hover': { backgroundColor: '#f9f9f9', borderColor: '#1976d2' },
//               }}
//               onClick={() => document.getElementById('property-images').click()}
//             >
//               <input
//                 type="file"
//                 id="property-images"
//                 multiple
//                 accept="image/*"
//                 style={{ display: 'none' }}
//                 onChange={handleImageUpload}
//               />
//               <CloudUpload sx={{ width: 24, height: 24, mr: 1, color: '#1976d2' }} />
//               <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#666', fontFamily: 'Outfit' }}>
//                 Upload (Max 10)
//               </Typography>
//             </Box>
//           </Box>
//         </Grid>
//       </Grid>

//       {/* Display uploaded images */}
//       {imagePreviews && imagePreviews.length > 0 && (
//         <Box sx={{ mb: 3 }}>
//           <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 1 }}>
//             {imagePreviews.length} {imagePreviews.length === 1 ? 'image' : 'images'} uploaded
//           </Typography>
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, p: 2, border: '1px solid #e0e0e0', borderRadius: 1.5, backgroundColor: '#fafafa' }}>
//             {imagePreviews.map((preview, index) => (
//               <Box
//                 key={`img-preview-${index}`}
//                 sx={{
//                   position: 'relative',
//                   width: '100px',
//                   height: '100px',
//                   borderRadius: 1.5,
//                   overflow: 'hidden',
//                   border: '2px solid #e0e0e0',
//                   cursor: 'pointer',
//                   flexShrink: 0,
//                   '&:hover': { borderColor: '#1976d2' }
//                 }}
//                 onClick={() => {
//                   setSelectedImageIndex(index);
//                   setPreviewOpen(true);
//                 }}
//               >
//                 <Box
//                   component="img"
//                   src={preview}
//                   alt={`Preview ${index + 1}`}
//                   sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
//                 />
//                 <IconButton
//                   size="small"
//                   sx={{
//                     position: 'absolute',
//                     top: -8,
//                     right: -8,
//                     bgcolor: '#ff4444',
//                     color: 'white',
//                     width: 24,
//                     height: 24,
//                     fontSize: '14px',
//                     '&:hover': { bgcolor: '#cc0000' }
//                   }}
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     const newPreviews = [...imagePreviews];
//                     const newFiles = [...propertyImages];
//                     newPreviews.splice(index, 1);
//                     newFiles.splice(index, 1);
//                     setImagePreviews(newPreviews);
//                     setPropertyImages(newFiles);
//                     if (newPreviews.length > 0) {
//                       localStorage.setItem('propertyImagePreviews', JSON.stringify(newPreviews));
//                     } else {
//                       localStorage.removeItem('propertyImagePreviews');
//                     }
//                   }}
//                 >
//                   ×
//                 </IconButton>
//               </Box>
//             ))}
//           </Box>
//         </Box>
//       )}

//       {/* Building Name & Area Name */}
//       <Grid container spacing={2} sx={{ mb: 3 }}>
//         <Grid item xs={12} sm="auto">
//           <Box sx={{ width: '410px', maxWidth: '100%' }}>
//             <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//               Building/Project Name <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <TextField
//               id="buildingName"
//               fullWidth
//               size="small"
//               placeholder="Enter building name"
//               value={buildingName}
//               onChange={(e) => {
//                 setBuildingName(e.target.value);
//                 setErrors(prev => ({...prev, buildingName: validateAlphanumeric(e.target.value, "Building name")}));
//               }}
//               error={!!errors.buildingName}
//               helperText={errors.buildingName}
//               sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//             />
//           </Box>
//         </Grid>

//         <Grid item xs={12} sm="auto">
//           <Box sx={{ width: '410px', maxWidth: '100%' }}>
//             <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//               Area Name <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <ClickAwayListener onClickAway={handleAreaClickAway}>
//               <Box sx={{ position: 'relative' }}>
//                 <TextField
//                   id="areaName"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter area name"
//                   value={areaName}
//                   onChange={handleAreaNameChange}
//                   error={!!errors.areaName}
//                   helperText={errors.areaName}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//                 {showAreaSuggestions && areaSuggestions.length > 0 && (
//                   <Popper
//                     open={showAreaSuggestions}
//                     anchorEl={areaAnchorEl}
//                     placement="bottom-start"
//                     transition
//                     style={{ width: areaAnchorEl ? areaAnchorEl.clientWidth : 'auto', zIndex: 1300 }}
//                   >
//                     {({ TransitionProps }) => (
//                       <Grow {...TransitionProps} timeout={200}>
//                         <Paper elevation={3} sx={{ maxHeight: 200, overflow: 'auto', mt: 0.5, border: '1px solid #e0e0e0', borderRadius: 1 }}>
//                           <List dense>
//                             {areaSuggestions.map((area, index) => (
//                               <ListItem
//                                 key={index}
//                                 button
//                                 onClick={() => handleSelectArea(area)}
//                                 sx={{ py: 0.8, '&:hover': { backgroundColor: '#f5f5f5' } }}
//                               >
//                                                              <ListItemText
//                                   primary={area.area}
//                                   primaryTypographyProps={{ fontFamily: 'Outfit', fontWeight: 500, fontSize: '13px' }}
//                                 />
//                               </ListItem>
//                             ))}
//                           </List>
//                         </Paper>
//                       </Grow>
//                     )}
//                   </Popper>
//                 )}
//               </Box>
//             </ClickAwayListener>
//           </Box>
//         </Grid>
//       </Grid>

//       {/* Complete Address & Description */}
//       <Grid container spacing={2} sx={{ mb: 3 }}>
//         <Grid item xs={12} sm="auto">
//           <Box sx={{ width: '400px', maxWidth: '100%' }}>
//             <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//               Complete Address <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <TextField
//               id="completeAddress"
//               fullWidth
//               size="small"
//               multiline
//               rows={3}
//               placeholder="Enter address (max 5 digits allowed)"
//               value={completeAddress}
//               onChange={(e) => {
//                 const value = e.target.value;
//                 const numbers = value.replace(/\D/g, '');
//                 if (numbers.length <= 5) {
//                   setCompleteAddress(value);
//                   setErrors(prev => ({...prev, completeAddress: validateAlphanumericField(value, "Complete address", true)}));
//                 }
//               }}
//               error={!!errors.completeAddress}
//               helperText={errors.completeAddress}
//               sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//             />
//           </Box>
//         </Grid>

//         <Grid item xs={12} sm="auto">
//           <Box sx={{ width: '400px', maxWidth: '100%' }}>
//             <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//               Description <span style={{ color: '#999', fontSize: '11px' }}>(Optional - max 5 digits)</span>
//             </Typography>
//             <TextField
//               id="propertyDescription"
//               fullWidth
//               size="small"
//               multiline
//               rows={3}
//               placeholder="Enter description (max 5 digits allowed)"
//               value={propertyDescription}
//               onChange={(e) => {
//                 const value = e.target.value;
//                 const numbers = value.replace(/\D/g, '');
//                 if (numbers.length <= 5) {
//                   setPropertyDescription(value);
//                   if (value) {
//                     setErrors(prev => ({...prev, propertyDescription: validateAlphanumericField(value, "Description", false)}));
//                   } else {
//                     setErrors(prev => ({...prev, propertyDescription: ''}));
//                   }
//                 }
//               }}
//               error={!!errors.propertyDescription}
//               helperText={errors.propertyDescription}
//               sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//             />
//           </Box>
//         </Grid>
//       </Grid>

//       {/* APARTMENT FIELDS */}
//       {isApartment && (
//         <>
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '280px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="socialMediaLink"
//                   fullWidth
//                   size="small"
//                   type="url"
//                   placeholder="YouTube, Facebook, WhatsApp, Instagram"
//                   value={socialMediaLink}
//                   onChange={(e) => {
//                     setSocialMediaLink(e.target.value);
//                     if (e.target.value) {
//                       setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
//                     } else {
//                       setErrors(prev => ({...prev, socialMediaLink: ''}));
//                     }
//                   }}
//                   error={!!errors.socialMediaLink}
//                   helperText={errors.socialMediaLink}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '210px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   BHK <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <FormControl fullWidth size="small" error={!!errors.bhk}>
//                   <Select
//                     value={selectedBHK}
//                     onChange={(e) => {
//                       setSelectedBHK(e.target.value);
//                       setErrors({...errors, bhk: ''});
//                     }}
//                     displayEmpty
//                     sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                   >
//                     <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
//                     {bhkOptions.map((option) => (
//                       <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
//                     ))}
//                   </Select>
//                   {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
//                 </FormControl>
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '210px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <FormControl fullWidth size="small" error={!!errors.furnish}>
//                   <Select
//                     value={selectedFurnish}
//                     onChange={(e) => {
//                       setSelectedFurnish(e.target.value);
//                       setErrors({...errors, furnish: ''});
//                     }}
//                     displayEmpty
//                     sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                   >
//                     <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
//                     {furnishTypes.map((type) => (
//                       <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
//                     ))}
//                   </Select>
//                   {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
//                 </FormControl>
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Contact Information */}
//           <Box sx={{ mb: 3 }}>
//             <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
//               Contact Information <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Owner Name
//                   </Typography>
//                   <TextField
//                     id="ownerName"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter owner name"
//                     value={ownerName}
//                     onChange={(e) => {
//                       setOwnerName(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
//                     error={!!errors.ownerName}
//                     helperText={errors.ownerName}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Contact Number
//                   </Typography>
//                   <TextField
//                     id="contactNumber"
//                     fullWidth
//                     size="small"
//                     type="tel"
//                     placeholder="Enter contact number"
//                     value={contactNumber}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       if (value === 'N/A' || value === '') {
//                         setContactNumber(value);
//                       } else {
//                         const numericValue = value.replace(/\D/g, '').slice(0, 10);
//                         setContactNumber(numericValue);
//                         if (numericValue !== 'N/A') {
//                           setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
//                         }
//                       }
//                     }}
//                     disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
//                     error={!!errors.contactNumber}
//                     helperText={errors.contactNumber}
//                     inputProps={{ maxLength: 10 }}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Email Address
//                   </Typography>
//                   <TextField
//                     id="emailAddress"
//                     fullWidth
//                     size="small"
//                     type="email"
//                     placeholder="Enter email address"
//                     value={emailAddress}
//                     onChange={(e) => {
//                       setEmailAddress(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
//                     error={!!errors.emailAddress}
//                     helperText={errors.emailAddress}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>
//             </Grid>
//           </Box>

//           {/* Carpet Area, Built-up Area, UDS */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Carpet Area <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <TextField
//                   id="carpetArea"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter carpet area"
//                   value={carpetArea}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setCarpetArea(value);
//                     setErrors(prev => ({...prev, carpetArea: validateNumber(value, "Carpet area")}));
//                   }}
//                   error={!!errors.carpetArea}
//                   helperText={errors.carpetArea}
//                   InputProps={{
//                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <TextField
//                   id="builtUpArea"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter built-up area"
//                   value={builtUpArea}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setBuiltUpArea(value);
//                     setErrors(prev => ({...prev, builtUpArea: validateNumber(value, "Built-up area")}));
//                   }}
//                   error={!!errors.builtUpArea}
//                   helperText={errors.builtUpArea}
//                   InputProps={{
//                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   UDS <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="uds"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter UDS"
//                   value={uds}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setUds(value);
//                   }}
//                   InputProps={{
//                     endAdornment: <InputAdornment position="end">Sq.Yards</InputAdornment>,
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>
//           </Grid>
//         </>
//       )}

//       {/* INDEPENDENT HOUSE FIELDS */}
//       {isIndependentHouse && (
//         <>
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '280px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="socialMediaLink"
//                   fullWidth
//                   size="small"
//                   type="url"
//                   placeholder="YouTube, Facebook, WhatsApp, Instagram"
//                   value={socialMediaLink}
//                   onChange={(e) => {
//                     setSocialMediaLink(e.target.value);
//                     if (e.target.value) {
//                       setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
//                     } else {
//                       setErrors(prev => ({...prev, socialMediaLink: ''}));
//                     }
//                   }}
//                   error={!!errors.socialMediaLink}
//                   helperText={errors.socialMediaLink}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '210px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   BHK <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <FormControl fullWidth size="small" error={!!errors.bhk}>
//                   <Select
//                     value={selectedBHK}
//                     onChange={(e) => {
//                       setSelectedBHK(e.target.value);
//                       setErrors({...errors, bhk: ''});
//                     }}
//                     displayEmpty
//                     sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                   >
//                     <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
//                     {bhkOptions.map((option) => (
//                       <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
//                     ))}
//                   </Select>
//                   {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
//                 </FormControl>
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '210px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <FormControl fullWidth size="small" error={!!errors.furnish}>
//                   <Select
//                     value={selectedFurnish}
//                     onChange={(e) => {
//                       setSelectedFurnish(e.target.value);
//                       setErrors({...errors, furnish: ''});
//                     }}
//                     displayEmpty
//                     sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                   >
//                     <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
//                     {furnishTypes.map((type) => (
//                       <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
//                     ))}
//                   </Select>
//                   {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
//                 </FormControl>
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Contact Information */}
//           <Box sx={{ mb: 3 }}>
//             <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
//               Contact Information <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Owner Name
//                   </Typography>
//                   <TextField
//                     id="ownerName"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter owner name"
//                     value={ownerName}
//                     onChange={(e) => {
//                       setOwnerName(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
//                     error={!!errors.ownerName}
//                     helperText={errors.ownerName}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Contact Number
//                   </Typography>
//                   <TextField
//                     id="contactNumber"
//                     fullWidth
//                     size="small"
//                     type="tel"
//                     placeholder="Enter contact number"
//                     value={contactNumber}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       if (value === 'N/A' || value === '') {
//                         setContactNumber(value);
//                       } else {
//                         const numericValue = value.replace(/\D/g, '').slice(0, 10);
//                         setContactNumber(numericValue);
//                         if (numericValue !== 'N/A') {
//                           setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
//                         }
//                       }
//                     }}
//                     disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
//                     error={!!errors.contactNumber}
//                     helperText={errors.contactNumber}
//                     inputProps={{ maxLength: 10 }}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Email Address
//                   </Typography>
//                   <TextField
//                     id="emailAddress"
//                     fullWidth
//                     size="small"
//                     type="email"
//                     placeholder="Enter email address"
//                     value={emailAddress}
//                     onChange={(e) => {
//                       setEmailAddress(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
//                     error={!!errors.emailAddress}
//                     helperText={errors.emailAddress}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>
//             </Grid>
//           </Box>

//           {/* Built-up Area, Property Size, UDS */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <TextField
//                   id="builtUpArea"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter built-up area"
//                   value={builtUpArea}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setBuiltUpArea(value);
//                     setErrors(prev => ({...prev, builtUpArea: validateNumber(value, "Built-up area")}));
//                   }}
//                   error={!!errors.builtUpArea}
//                   helperText={errors.builtUpArea}
//                   InputProps={{
//                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <TextField
//                   id="propertySize"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter property size"
//                   value={propertySize}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setPropertySize(value);
//                     setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
//                   }}
//                   error={!!errors.propertySize}
//                   helperText={errors.propertySize}
//                   InputProps={{
//                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   UDS <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="uds"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter UDS"
//                   value={uds}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setUds(value);
//                   }}
//                   InputProps={{
//                     endAdornment: <InputAdornment position="end">Sq.Yards</InputAdornment>,
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>
//           </Grid>
//         </>
//       )}

//            {/* PENT HOUSE FIELDS */}
//       {isPentHouse && (
//         <>
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '280px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="socialMediaLink"
//                   fullWidth
//                   size="small"
//                   type="url"
//                   placeholder="YouTube, Facebook, WhatsApp, Instagram"
//                   value={socialMediaLink}
//                   onChange={(e) => {
//                     setSocialMediaLink(e.target.value);
//                     if (e.target.value) {
//                       setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
//                     } else {
//                       setErrors(prev => ({...prev, socialMediaLink: ''}));
//                     }
//                   }}
//                   error={!!errors.socialMediaLink}
//                   helperText={errors.socialMediaLink}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '210px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   BHK <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <FormControl fullWidth size="small" error={!!errors.bhk}>
//                   <Select
//                     value={selectedBHK}
//                     onChange={(e) => {
//                       setSelectedBHK(e.target.value);
//                       setErrors({...errors, bhk: ''});
//                     }}
//                     displayEmpty
//                     sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                   >
//                     <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
//                     {bhkOptions.map((option) => (
//                       <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
//                     ))}
//                   </Select>
//                   {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
//                 </FormControl>
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '210px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <FormControl fullWidth size="small" error={!!errors.furnish}>
//                   <Select
//                     value={selectedFurnish}
//                     onChange={(e) => {
//                       setSelectedFurnish(e.target.value);
//                       setErrors({...errors, furnish: ''});
//                     }}
//                     displayEmpty
//                     sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                   >
//                     <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
//                     {furnishTypes.map((type) => (
//                       <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
//                     ))}
//                   </Select>
//                   {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
//                 </FormControl>
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Contact Information */}
//           <Box sx={{ mb: 3 }}>
//             <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
//               Contact Information <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Owner Name
//                   </Typography>
//                   <TextField
//                     id="ownerName"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter owner name"
//                     value={ownerName}
//                     onChange={(e) => {
//                       setOwnerName(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
//                     error={!!errors.ownerName}
//                     helperText={errors.ownerName}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Contact Number
//                   </Typography>
//                   <TextField
//                     id="contactNumber"
//                     fullWidth
//                     size="small"
//                     type="tel"
//                     placeholder="Enter contact number"
//                     value={contactNumber}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       if (value === 'N/A' || value === '') {
//                         setContactNumber(value);
//                       } else {
//                         const numericValue = value.replace(/\D/g, '').slice(0, 10);
//                         setContactNumber(numericValue);
//                         if (numericValue !== 'N/A') {
//                           setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
//                         }
//                       }
//                     }}
//                     disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
//                     error={!!errors.contactNumber}
//                     helperText={errors.contactNumber}
//                     inputProps={{ maxLength: 10 }}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Email Address
//                   </Typography>
//                   <TextField
//                     id="emailAddress"
//                     fullWidth
//                     size="small"
//                     type="email"
//                     placeholder="Enter email address"
//                     value={emailAddress}
//                     onChange={(e) => {
//                       setEmailAddress(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
//                     error={!!errors.emailAddress}
//                     helperText={errors.emailAddress}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>
//             </Grid>
//           </Box>

//           {/* Built-up Area ONLY */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <TextField
//                   id="builtUpArea"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter built-up area"
//                   value={builtUpArea}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setBuiltUpArea(value);
//                     setErrors(prev => ({...prev, builtUpArea: validateNumber(value, "Built-up area")}));
//                   }}
//                   error={!!errors.builtUpArea}
//                   helperText={errors.builtUpArea}
//                   InputProps={{
//                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>
//           </Grid>
//         </>
//       )}

//       {/* STUDIO FIELDS */}
//       {isStudio && (
//         <>
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '280px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="socialMediaLink"
//                   fullWidth
//                   size="small"
//                   type="url"
//                   placeholder="YouTube, Facebook, WhatsApp, Instagram"
//                   value={socialMediaLink}
//                   onChange={(e) => {
//                     setSocialMediaLink(e.target.value);
//                     if (e.target.value) {
//                       setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
//                     } else {
//                       setErrors(prev => ({...prev, socialMediaLink: ''}));
//                     }
//                   }}
//                   error={!!errors.socialMediaLink}
//                   helperText={errors.socialMediaLink}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '210px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   BHK <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <FormControl fullWidth size="small" error={!!errors.bhk}>
//                   <Select
//                     value={selectedBHK}
//                     onChange={(e) => {
//                       setSelectedBHK(e.target.value);
//                       setErrors({...errors, bhk: ''});
//                     }}
//                     displayEmpty
//                     sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                   >
//                     <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
//                     {bhkOptions.map((option) => (
//                       <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
//                     ))}
//                   </Select>
//                   {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
//                 </FormControl>
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '210px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <FormControl fullWidth size="small" error={!!errors.furnish}>
//                   <Select
//                     value={selectedFurnish}
//                     onChange={(e) => {
//                       setSelectedFurnish(e.target.value);
//                       setErrors({...errors, furnish: ''});
//                     }}
//                     displayEmpty
//                     sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                   >
//                     <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
//                     {furnishTypes.map((type) => (
//                       <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
//                     ))}
//                   </Select>
//                   {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
//                 </FormControl>
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Contact Information */}
//           <Box sx={{ mb: 3 }}>
//             <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
//               Contact Information <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Owner Name
//                   </Typography>
//                   <TextField
//                     id="ownerName"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter owner name"
//                     value={ownerName}
//                     onChange={(e) => {
//                       setOwnerName(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
//                     error={!!errors.ownerName}
//                     helperText={errors.ownerName}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Contact Number
//                   </Typography>
//                   <TextField
//                     id="contactNumber"
//                     fullWidth
//                     size="small"
//                     type="tel"
//                     placeholder="Enter contact number"
//                     value={contactNumber}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       if (value === 'N/A' || value === '') {
//                         setContactNumber(value);
//                       } else {
//                         const numericValue = value.replace(/\D/g, '').slice(0, 10);
//                         setContactNumber(numericValue);
//                         if (numericValue !== 'N/A') {
//                           setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
//                         }
//                       }
//                     }}
//                     disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
//                     error={!!errors.contactNumber}
//                     helperText={errors.contactNumber}
//                     inputProps={{ maxLength: 10 }}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Email Address
//                   </Typography>
//                   <TextField
//                     id="emailAddress"
//                     fullWidth
//                     size="small"
//                     type="email"
//                     placeholder="Enter email address"
//                     value={emailAddress}
//                     onChange={(e) => {
//                       setEmailAddress(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
//                     error={!!errors.emailAddress}
//                     helperText={errors.emailAddress}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>
//             </Grid>
//           </Box>

//           {/* Property Size */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <TextField
//                   id="propertySize"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter property size"
//                   value={propertySize}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setPropertySize(value);
//                     setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
//                   }}
//                   error={!!errors.propertySize}
//                   helperText={errors.propertySize}
//                   InputProps={{
//                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>
//           </Grid>
//         </>
//       )}

//       {/* VILLA FIELDS */}
//       {isVilla && (
//         <>
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '280px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="socialMediaLink"
//                   fullWidth
//                   size="small"
//                   type="url"
//                   placeholder="YouTube, Facebook, WhatsApp, Instagram"
//                   value={socialMediaLink}
//                   onChange={(e) => {
//                     setSocialMediaLink(e.target.value);
//                     if (e.target.value) {
//                       setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
//                     } else {
//                       setErrors(prev => ({...prev, socialMediaLink: ''}));
//                     }
//                   }}
//                   error={!!errors.socialMediaLink}
//                   helperText={errors.socialMediaLink}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '210px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   BHK <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <FormControl fullWidth size="small" error={!!errors.bhk}>
//                   <Select
//                     value={selectedBHK}
//                     onChange={(e) => {
//                       setSelectedBHK(e.target.value);
//                       setErrors({...errors, bhk: ''});
//                     }}
//                     displayEmpty
//                     sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                   >
//                     <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
//                     {bhkOptions.map((option) => (
//                       <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
//                     ))}
//                   </Select>
//                   {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
//                 </FormControl>
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '210px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <FormControl fullWidth size="small" error={!!errors.furnish}>
//                   <Select
//                     value={selectedFurnish}
//                     onChange={(e) => {
//                       setSelectedFurnish(e.target.value);
//                       setErrors({...errors, furnish: ''});
//                     }}
//                     displayEmpty
//                     sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                   >
//                     <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
//                     {furnishTypes.map((type) => (
//                       <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
//                     ))}
//                   </Select>
//                   {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
//                 </FormControl>
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Contact Information */}
//           <Box sx={{ mb: 3 }}>
//             <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
//               Contact Information <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Owner Name
//                   </Typography>
//                   <TextField
//                     id="ownerName"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter owner name"
//                     value={ownerName}
//                     onChange={(e) => {
//                       setOwnerName(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
//                     error={!!errors.ownerName}
//                     helperText={errors.ownerName}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Contact Number
//                   </Typography>
//                   <TextField
//                     id="contactNumber"
//                     fullWidth
//                     size="small"
//                     type="tel"
//                     placeholder="Enter contact number"
//                     value={contactNumber}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       if (value === 'N/A' || value === '') {
//                         setContactNumber(value);
//                       } else {
//                         const numericValue = value.replace(/\D/g, '').slice(0, 10);
//                         setContactNumber(numericValue);
//                         if (numericValue !== 'N/A') {
//                           setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
//                         }
//                       }
//                     }}
//                     disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
//                     error={!!errors.contactNumber}
//                     helperText={errors.contactNumber}
//                     inputProps={{ maxLength: 10 }}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                     Email Address
//                   </Typography>
//                                     <TextField
//                     id="emailAddress"
//                     fullWidth
//                     size="small"
//                     type="email"
//                     placeholder="Enter email address"
//                     value={emailAddress}
//                     onChange={(e) => {
//                       setEmailAddress(e.target.value);
//                       if (e.target.value !== 'N/A') {
//                         setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
//                       }
//                     }}
//                     disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
//                     error={!!errors.emailAddress}
//                     helperText={errors.emailAddress}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         fontFamily: 'Outfit',
//                         fontSize: '13px',
//                         backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
//                       }
//                     }}
//                   />
//                 </Box>
//               </Grid>
//             </Grid>
//           </Box>

//           {/* Built-up Area and Property Size */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <TextField
//                   id="builtUpArea"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter built-up area"
//                   value={builtUpArea}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setBuiltUpArea(value);
//                     setErrors(prev => ({...prev, builtUpArea: validateNumber(value, "Built-up area")}));
//                   }}
//                   error={!!errors.builtUpArea}
//                   helperText={errors.builtUpArea}
//                   InputProps={{
//                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <TextField
//                   id="propertySize"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter property size"
//                   value={propertySize}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setPropertySize(value);
//                     setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
//                   }}
//                   error={!!errors.propertySize}
//                   helperText={errors.propertySize}
//                   InputProps={{
//                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>
//           </Grid>
//         </>
//       )}

//       {/* PLOT & AGRICULTURE LAND FIELDS */}
//       {(isPlot || isAgricultureLand) && (
//         <>
//           {/* Social Media Link */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '410px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="socialMediaLink"
//                   fullWidth
//                   size="small"
//                   type="url"
//                   placeholder="YouTube, Facebook, WhatsApp, Instagram"
//                   value={socialMediaLink}
//                   onChange={(e) => {
//                     setSocialMediaLink(e.target.value);
//                     if (e.target.value) {
//                       setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
//                     } else {
//                       setErrors(prev => ({...prev, socialMediaLink: ''}));
//                     }
//                   }}
//                   error={!!errors.socialMediaLink}
//                   helperText={errors.socialMediaLink}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Property Size, Zone Type, Ownership */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <Box sx={{ display: 'flex', gap: 1 }}>
//                   <TextField
//                     id="propertySize"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter size"
//                     value={propertySize}
//                     onChange={(e) => {
//                       const value = e.target.value.replace(/[^0-9]/g, '');
//                       setPropertySize(value);
//                       setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
//                     }}
//                     error={!!errors.propertySize}
//                     helperText={errors.propertySize}
//                     sx={{ 
//                       flex: 1,
//                       '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } 
//                     }}
//                   />
//                   <FormControl size="small" sx={{ minWidth: 100 }}>
//                     <Select
//                       value={selectedUnit}
//                       onChange={(e) => setSelectedUnit(e.target.value)}
//                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                     >
//                       <MenuItem value="sq.yards">Sq.Yards</MenuItem>
//                       <MenuItem value="acres">Acres</MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Box>
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="zoneType"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter zone type"
//                   value={zoneType}
//                   onChange={(e) => setZoneType(e.target.value)}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Ownership <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <FormControl fullWidth size="small">
//                   <Select
//                     value={selectedOwnership}
//                     onChange={(e) => setSelectedOwnership(e.target.value)}
//                     displayEmpty
//                     sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                   >
//                     <MenuItem value=""><em>Select Ownership</em></MenuItem>
//                     {ownerships.map((own) => (
//                       <MenuItem key={own} value={own}>{own}</MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Length and Width (only for Plot, not for Agriculture Land) */}
//           {!isAgricultureLand && (
//             <Grid container spacing={2} sx={{ mb: 3 }}>
//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     Length <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                   </Typography>
//                   <TextField
//                     id="propertyLength"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter length"
//                     value={propertyLength}
//                     onChange={(e) => {
//                       const value = e.target.value.replace(/[^0-9]/g, '');
//                       setPropertyLength(value);
//                     }}
//                     InputProps={{
//                       endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                     }}
//                     sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                   />
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     Width <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                   </Typography>
//                   <TextField
//                     id="propertyWidth"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter width"
//                     value={propertyWidth}
//                     onChange={(e) => {
//                       const value = e.target.value.replace(/[^0-9]/g, '');
//                       setPropertyWidth(value);
//                     }}
//                     InputProps={{
//                       endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                     }}
//                     sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                   />
//                 </Box>
//               </Grid>
//             </Grid>
//           )}
//         </>
//       )}

//       {/* FARMHOUSE FIELDS */}
//       {isFarmhouse && (
//         <>
//           {/* Social Media Link, BHK, Furnish Type */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '300px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   id="socialMediaLink"
//                   fullWidth
//                   size="small"
//                   type="url"
//                   placeholder="YouTube, Facebook, WhatsApp, Instagram"
//                   value={socialMediaLink}
//                   onChange={(e) => {
//                     setSocialMediaLink(e.target.value);
//                     if (e.target.value) {
//                       setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
//                     } else {
//                       setErrors(prev => ({...prev, socialMediaLink: ''}));
//                     }
//                   }}
//                   error={!!errors.socialMediaLink}
//                   helperText={errors.socialMediaLink}
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '180px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   BHK <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <FormControl fullWidth size="small" error={!!errors.bhk}>
//                   <Select
//                     value={selectedBHK}
//                     onChange={(e) => {
//                       setSelectedBHK(e.target.value);
//                       setErrors({...errors, bhk: ''});
//                     }}
//                     displayEmpty
//                     sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                   >
//                     <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
//                     {bhkOptions.map((option) => (
//                       <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
//                     ))}
//                   </Select>
//                   {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
//                 </FormControl>
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '230px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <FormControl fullWidth size="small" error={!!errors.furnish}>
//                   <Select
//                     value={selectedFurnish}
//                     onChange={(e) => {
//                       setSelectedFurnish(e.target.value);
//                       setErrors({...errors, furnish: ''});
//                     }}
//                     displayEmpty
//                     sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                   >
//                     <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
//                     {furnishTypes.map((type) => (
//                       <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
//                     ))}
//                   </Select>
//                   {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
//                 </FormControl>
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Built-up Area and Property Size */}
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <TextField
//                   id="builtUpArea"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter built-up area"
//                   value={builtUpArea}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setBuiltUpArea(value);
//                     setErrors(prev => ({...prev, builtUpArea: validateNumber(value, "Built-up area")}));
//                   }}
//                   error={!!errors.builtUpArea}
//                   helperText={errors.builtUpArea}
//                   InputProps={{
//                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>

//             <Grid item xs={12} sm="auto">
//               <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <TextField
//                   id="propertySize"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter property size"
//                   value={propertySize}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setPropertySize(value);
//                     setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
//                   }}
//                   error={!!errors.propertySize}
//                   helperText={errors.propertySize}
//                   InputProps={{
//                     endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>
//             </Grid>
//           </Grid>
//         </>
//       )}

//       {/* Image Preview Dialog */}
//       {imagePreviews.length > 0 && (
//         <Dialog
//           open={previewOpen}
//           onClose={() => setPreviewOpen(false)}
//           maxWidth="md"
//           fullWidth
//           sx={{ '& .MuiDialog-paper': { borderRadius: '12px', overflow: 'hidden', bgcolor: 'black' } }}
//         >
//           <DialogContent sx={{ p: 0, position: 'relative' }}>
//             <Box
//               component="img"
//               src={imagePreviews[selectedImageIndex]}
//               alt={`Image ${selectedImageIndex + 1}`}
//               sx={{ width: '100%', height: 'auto', maxHeight: '80vh', objectFit: 'contain' }}
//             />
//             <IconButton
//               onClick={() => setPreviewOpen(false)}
//               sx={{
//                 position: 'absolute',
//                 top: 8,
//                 right: 8,
//                 bgcolor: 'rgba(255, 255, 255, 0.3)',
//                 color: 'white',
//                 '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
//               }}
//             >
//               <CloseIcon />
//             </IconButton>
//             {imagePreviews.length > 1 && (
//               <>
//                 <IconButton
//                   onClick={() => setSelectedImageIndex(prev => (prev > 0 ? prev - 1 : imagePreviews.length - 1))}
//                   sx={{
//                     position: 'absolute',
//                     left: 8,
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     bgcolor: 'rgba(255, 255, 255, 0.3)',
//                     color: 'white',
//                     '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
//                   }}
//                 >
//                   ‹
//                 </IconButton>
//                 <IconButton
//                   onClick={() => setSelectedImageIndex(prev => (prev < imagePreviews.length - 1 ? prev + 1 : 0))}
//                   sx={{
//                     position: 'absolute',
//                     right: 8,
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     bgcolor: 'rgba(255, 255, 255, 0.3)',
//                     color: 'white',
//                     '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
//                   }}
//                 >
//                   ›
//                 </IconButton>
//                 <Box
//                   sx={{
//                     position: 'absolute',
//                     bottom: 16,
//                     left: '50%',
//                     transform: 'translateX(-50%)',
//                     bgcolor: 'rgba(0, 0, 0, 0.7)',
//                     color: 'white',
//                     px: 2,
//                     py: 1,
//                     borderRadius: '16px',
//                     fontSize: '14px',
//                     fontFamily: 'Outfit'
//                   }}
//                 >
//                   {selectedImageIndex + 1} / {imagePreviews.length}
//                 </Box>
//               </>
//             )}
//           </DialogContent>
//         </Dialog>
//       )}
//     </Box>
//   );
// };

// export default PropertyResidential;


import React from 'react';
import {
  Box,
  Typography,
  TextField,
  Grid,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  InputAdornment,
  IconButton,
  Dialog,
  DialogContent,
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import CloudUpload from '@mui/icons-material/CloudUpload';
import LinkIcon from '@mui/icons-material/Link';
import CloseIcon from '@mui/icons-material/Close';

const PropertyResidential = ({
  residentialPropertyTypes,
  setResidentialPropertyTypes,
  selectedPropertyType,
  setSelectedPropertyType,
  propertyImages,
  setPropertyImages,
  imagePreviews,
  setImagePreviews,
  buildingName,
  setBuildingName,
  areaName,
  setAreaName,
  completeAddress,
  setCompleteAddress,
  propertyDescription,
  setPropertyDescription,
  socialMediaLink,
  setSocialMediaLink,
  selectedBHK,
  setSelectedBHK,
  selectedFurnish,
  setSelectedFurnish,
  bhkOptions,
  furnishTypes,
  carpetArea,
  setCarpetArea,
  carpetAreaUnits,
  setCarpetAreaUnits,
  builtUpArea,
  setBuiltUpArea,
  builtUpAreaUnits,
  setBuiltUpAreaUnits,
  uds,
  setUds,
  udsUnits,
  setUdsUnits,
  propertySize,
  setPropertySize,
  selectedUnit,
  setSelectedUnit,
  propertyLength,
  setPropertyLength,
  lengthUnit,
  setLengthUnit,
  propertyWidth,
  setPropertyWidth,
  widthUnit,
  setWidthUnit,
  zoneType,
  setZoneType,
  selectedOwnership,
  setSelectedOwnership,
  ownerships,
  ownerName,
  setOwnerName,
  contactNumber,
  setContactNumber,
  emailAddress,
  setEmailAddress,
  profileData,
  errors,
  setErrors,
  areaSuggestions,
  setAreaSuggestions,
  showAreaSuggestions,
  setShowAreaSuggestions,
  areaAnchorEl,
  setAreaAnchorEl,
  selectedAreaDetails,
  setSelectedAreaDetails,
  selectedImageIndex,
  setSelectedImageIndex,
  previewOpen,
  setPreviewOpen,
  validateAlphanumeric,
  validateName,
  validateNumber,
  validateEmail,
  validatePhone,
  validateAlphanumericField,
  validateSocialMediaLink,
  location,
}) => {
  const selectedType = residentialPropertyTypes.find(type => type.id === selectedPropertyType);
  const isPlot = selectedType?.id === 'plot';
  const isAgricultureLand = selectedType?.id === 'agriculture-land';
  const isFarmhouse = selectedType?.id === 'farm-house';
  const isVilla = selectedType?.id === 'villa';
  const isApartment = selectedType?.id === 'apartment';
  const isIndependentHouse = selectedType?.id === 'independent-house';
  const isPentHouse = selectedType?.id === 'pent-house';
  const isStudio = selectedType?.id === 'studio';

  // Get category from location state
  const category = location.state?.category || 'Sell';
  const isRental = category === 'Rent';

  const handlePropertyTypeSelect = (typeId) => {
    setSelectedPropertyType(typeId);
    const updatedTypes = residentialPropertyTypes.map(type => ({
      ...type,
      selected: type.id === typeId
    }));
    setResidentialPropertyTypes(updatedTypes);
  };

  const handleImageUpload = (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;
    if (files.length > 10) {
      alert("You can only upload up to 10 images");
      return;
    }

    const validFiles = Array.from(files).filter(file => file.type.startsWith('image/'));
    if (validFiles.length !== files.length) {
      alert("Only image files are allowed (JPEG, PNG, GIF, etc.)");
      return;
    }

    const newPreviews = [];
    const fileProcessPromises = validFiles.map(file => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          newPreviews.push(e.target.result);
          resolve();
        };
        reader.onerror = () => {
          console.error(`Failed to read file: ${file.name}`);
          resolve();
        };
        reader.readAsDataURL(file);
      });
    });

    Promise.all(fileProcessPromises).then(() => {
      const updatedPreviews = [...imagePreviews, ...newPreviews];
      const updatedFiles = [...propertyImages, ...validFiles];
      setImagePreviews(updatedPreviews);
      setPropertyImages(updatedFiles);
      localStorage.setItem('propertyImagePreviews', JSON.stringify(updatedPreviews));
      if (errors.propertyImages) {
        setErrors(prev => ({...prev, propertyImages: ''}));
      }
    });
  };

  const handleAreaNameChange = (e) => {
    const value = e.target.value;
    setAreaName(value);
    setAreaAnchorEl(e.currentTarget);
    if (!value) {
      setErrors(prev => ({...prev, areaName: 'Area Name is required'}));
    } else if (value.trim().length < 1) {
      setErrors(prev => ({...prev, areaName: 'Area Name must be at least 3 characters'}));
    } else {
      setErrors(prev => ({...prev, areaName: ''}));
    }
  };

  const handleSelectArea = (area) => {
    setAreaName(area.area);
    setSelectedAreaDetails({
      name: area.area,
      address: area.address,
      location: area.location
    });
    setAreaAnchorEl(null);
    setShowAreaSuggestions(false);
    setErrors(prev => ({...prev, areaName: ''}));
  };

  const handleAreaClickAway = () => {
    setShowAreaSuggestions(false);
  };

  const fetchAreaSuggestions = async (query, city) => {
    if (query.length < 1 || !city) return;
    try {
      const response = await fetch(`https://propertydealstalk.com/api/property/getAreasByCity?city=${encodeURIComponent(city)}&q=${encodeURIComponent(query)}`);
      const data = await response.json();
      if (data.success && data.areas && data.areas.length > 0) {
        const transformedAreas = data.areas.map(area => ({
          area: area.name,
          address: area.address,
          location: area.location
        }));
        setAreaSuggestions(transformedAreas);
        setShowAreaSuggestions(true);
      } else {
        setAreaSuggestions([]);
        setShowAreaSuggestions(false);
      }
    } catch (error) {
      console.error('Error fetching area suggestions:', error);
      setAreaSuggestions([]);
      setShowAreaSuggestions(false);
    }
  };

  React.useEffect(() => {
    if (areaName.trim().length > 0 && location.state?.location) {
      fetchAreaSuggestions(areaName, location.state.location);
    } else {
      setAreaSuggestions([]);
      setShowAreaSuggestions(false);
    }
  }, [areaName, location.state?.location]);

  return (
    <Box>
      {/* Property Type & Upload Images */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm="auto">
          <Box sx={{ width: '410px', maxWidth: '100%' }}>
            <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
              Property Type <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <FormControl fullWidth size="small">
              <Select
                value={selectedPropertyType || 'apartment'}
                onChange={(e) => handlePropertyTypeSelect(e.target.value)}
                displayEmpty
                sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                renderValue={(selected) => {
                  const selectedTypeObj = residentialPropertyTypes.find(type => type.id === selected);
                  if (!selectedTypeObj) {
                    return <em style={{ color: '#999' }}>Select Property Type</em>;
                  }
                  return (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Box component="img" src={selectedTypeObj.icon} alt={selectedTypeObj.name} sx={{ width: 20, height: 20, objectFit: 'contain' }} />
                      <Typography sx={{ fontFamily: 'Outfit', fontSize: '13px' }}>
                        {selectedTypeObj.name}
                      </Typography>
                    </Box>
                  );
                }}
              >
                {residentialPropertyTypes.map((type) => (
                  <MenuItem key={type.id} value={type.id}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Box component="img" src={type.icon} alt={type.name} sx={{ width: 20, height: 20, objectFit: 'contain' }} />
                      {type.name}
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Grid>

        <Grid item xs={12} sm="auto">
          <Box sx={{ width: '410px', maxWidth: '100%' }}>
            <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
              Upload Images <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <Box
              sx={{
                height: 36,
                border: `2px dashed ${errors.propertyImages ? '#d32f2f' : '#d0d0d0'}`,
                borderRadius: 1.5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                '&:hover': { backgroundColor: '#f9f9f9', borderColor: '#1976d2' },
              }}
              onClick={() => document.getElementById('property-images').click()}
            >
              <input
                type="file"
                id="property-images"
                multiple
                accept="image/*"
                style={{ display: 'none' }}
                onChange={handleImageUpload}
              />
              <CloudUpload sx={{ width: 24, height: 24, mr: 1, color: '#1976d2' }} />
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#666', fontFamily: 'Outfit' }}>
                Upload (Max 10)
              </Typography>
            </Box>
            {errors.propertyImages && (
              <Typography sx={{ fontSize: '11px', color: '#d32f2f', mt: 0.5, fontFamily: 'Outfit' }}>
                {errors.propertyImages}
              </Typography>
            )}
          </Box>
        </Grid>
      </Grid>

      {/* Display uploaded images */}
      {imagePreviews && imagePreviews.length > 0 && (
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 1 }}>
            {imagePreviews.length} {imagePreviews.length === 1 ? 'image' : 'images'} uploaded
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, p: 2, border: '1px solid #e0e0e0', borderRadius: 1.5, backgroundColor: '#fafafa' }}>
            {imagePreviews.map((preview, index) => (
              <Box
                key={`img-preview-${index}`}
                sx={{
                  position: 'relative',
                  width: '100px',
                  height: '100px',
                  borderRadius: 1.5,
                  overflow: 'hidden',
                  border: '2px solid #e0e0e0',
                  cursor: 'pointer',
                  flexShrink: 0,
                  '&:hover': { borderColor: '#1976d2' }
                }}
                onClick={() => {
                  setSelectedImageIndex(index);
                  setPreviewOpen(true);
                }}
              >
                <Box
                  component="img"
                  src={preview}
                  alt={`Preview ${index + 1}`}
                  sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
                <IconButton
                  size="small"
                  sx={{
                    position: 'absolute',
                    top: -8,
                    right: -8,
                    bgcolor: '#ff4444',
                    color: 'white',
                    width: 24,
                    height: 24,
                    fontSize: '14px',
                    '&:hover': { bgcolor: '#cc0000' }
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    const newPreviews = [...imagePreviews];
                    const newFiles = [...propertyImages];
                    newPreviews.splice(index, 1);
                    newFiles.splice(index, 1);
                    setImagePreviews(newPreviews);
                    setPropertyImages(newFiles);
                    if (newPreviews.length > 0) {
                      localStorage.setItem('propertyImagePreviews', JSON.stringify(newPreviews));
                    } else {
                      localStorage.removeItem('propertyImagePreviews');
                    }
                  }}
                >
                  ×
                </IconButton>
              </Box>
            ))}
          </Box>
        </Box>
      )}

      {/* Building Name & Area Name */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm="auto">
          <Box sx={{ width: '410px', maxWidth: '100%' }}>
            <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
              Building/Project Name <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <TextField
              id="buildingName"
              fullWidth
              size="small"
              placeholder="Enter building name"
              value={buildingName}
              onChange={(e) => {
                setBuildingName(e.target.value);
                setErrors(prev => ({...prev, buildingName: validateAlphanumeric(e.target.value, "Building name")}));
              }}
              error={!!errors.buildingName}
              helperText={errors.buildingName}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
            />
          </Box>
        </Grid>

        <Grid item xs={12} sm="auto">
          <Box sx={{ width: '410px', maxWidth: '100%' }}>
            <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
              Area Name <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <ClickAwayListener onClickAway={handleAreaClickAway}>
              <Box sx={{ position: 'relative' }}>
                <TextField
                  id="areaName"
                  fullWidth
                  size="small"
                  placeholder="Enter area name"
                  value={areaName}
                  onChange={handleAreaNameChange}
                  error={!!errors.areaName}
                  helperText={errors.areaName}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
                {showAreaSuggestions && areaSuggestions.length > 0 && (
                  <Popper
                    open={showAreaSuggestions}
                    anchorEl={areaAnchorEl}
                    placement="bottom-start"
                    transition
                    style={{ width: areaAnchorEl ? areaAnchorEl.clientWidth : 'auto', zIndex: 1300 }}
                  >
                    {({ TransitionProps }) => (
                      <Grow {...TransitionProps} timeout={200}>
                        <Paper elevation={3} sx={{ maxHeight: 200, overflow: 'auto', mt: 0.5, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                          <List dense>
                            {areaSuggestions.map((area, index) => (
                              <ListItem
                                key={index}
                                button
                                onClick={() => handleSelectArea(area)}
                                sx={{ py: 0.8, '&:hover': { backgroundColor: '#f5f5f5' } }}
                              >
                                <ListItemText
                                  primary={area.area}
                                  primaryTypographyProps={{ fontFamily: 'Outfit', fontWeight: 500, fontSize: '13px' }}
                                />
                              </ListItem>
                            ))}
                          </List>
                        </Paper>
                      </Grow>
                    )}
                  </Popper>
                )}
              </Box>
            </ClickAwayListener>
          </Box>
        </Grid>
      </Grid>

      {/* Complete Address & Description */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm="auto">
          <Box sx={{ width: '400px', maxWidth: '100%' }}>
            <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
              Complete Address <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <TextField
              id="completeAddress"
              fullWidth
              size="small"
              multiline
              rows={3}
              placeholder="Enter address (max 5 digits allowed)"
              value={completeAddress}
              onChange={(e) => {
                const value = e.target.value;
                const numbers = value.replace(/\D/g, '');
                if (numbers.length <= 5) {
                  setCompleteAddress(value);
                  setErrors(prev => ({...prev, completeAddress: validateAlphanumericField(value, "Complete address", true)}));
                }
              }}
              error={!!errors.completeAddress}
              helperText={errors.completeAddress}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
            />
          </Box>
        </Grid>

        <Grid item xs={12} sm="auto">
          <Box sx={{ width: '400px', maxWidth: '100%' }}>
            <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
              Description <span style={{ color: '#999', fontSize: '11px' }}>(Optional - max 5 digits)</span>
            </Typography>
            <TextField
              id="propertyDescription"
              fullWidth
              size="small"
              multiline
              rows={3}
              placeholder="Enter description (max 5 digits allowed)"
              value={propertyDescription}
              onChange={(e) => {
                const value = e.target.value;
                const numbers = value.replace(/\D/g, '');
                if (numbers.length <= 5) {
                  setPropertyDescription(value);
                  if (value) {
                    setErrors(prev => ({...prev, propertyDescription: validateAlphanumericField(value, "Description", false)}));
                  } else {
                    setErrors(prev => ({...prev, propertyDescription: ''}));
                  }
                }
              }}
              error={!!errors.propertyDescription}
              helperText={errors.propertyDescription}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
            />
          </Box>
        </Grid>
      </Grid>

      {/* APARTMENT FIELDS */}
      {isApartment && (
        <>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '280px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="socialMediaLink"
                  fullWidth
                  size="small"
                  type="url"
                  placeholder="YouTube, Facebook, WhatsApp, Instagram"
                  value={socialMediaLink}
                  onChange={(e) => {
                    setSocialMediaLink(e.target.value);
                    if (e.target.value) {
                      setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
                    } else {
                      setErrors(prev => ({...prev, socialMediaLink: ''}));
                    }
                  }}
                  error={!!errors.socialMediaLink}
                  helperText={errors.socialMediaLink}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '210px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  BHK <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <FormControl fullWidth size="small" error={!!errors.bhk}>
                  <Select
                    value={selectedBHK}
                    onChange={(e) => {
                      setSelectedBHK(e.target.value);
                      setErrors({...errors, bhk: ''});
                    }}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
                    {bhkOptions.map((option) => (
                      <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                    ))}
                  </Select>
                  {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '210px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <FormControl fullWidth size="small" error={!!errors.furnish}>
                  <Select
                    value={selectedFurnish}
                    onChange={(e) => {
                      setSelectedFurnish(e.target.value);
                      setErrors({...errors, furnish: ''});
                    }}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
                    {furnishTypes.map((type) => (
                      <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
                    ))}
                  </Select>
                  {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
                </FormControl>
              </Box>
            </Grid>
          </Grid>

          {/* Carpet Area, Built-up Area, UDS */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Carpet Area <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <TextField
                  id="carpetArea"
                  fullWidth
                  size="small"
                  placeholder="Enter carpet area"
                  value={carpetArea}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setCarpetArea(value);
                    setErrors(prev => ({...prev, carpetArea: validateNumber(value, "Carpet area")}));
                  }}
                  error={!!errors.carpetArea}
                  helperText={errors.carpetArea}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <TextField
                  id="builtUpArea"
                  fullWidth
                  size="small"
                  placeholder="Enter built-up area"
                  value={builtUpArea}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setBuiltUpArea(value);
                    setErrors(prev => ({...prev, builtUpArea: validateNumber(value, "Built-up area")}));
                  }}
                  error={!!errors.builtUpArea}
                  helperText={errors.builtUpArea}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            {/* UDS field - Optional and NOT shown for rental properties */}
            {!isRental && (
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    UDS <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                  </Typography>
                  <TextField
                    id="uds"
                    fullWidth
                    size="small"
                    placeholder="Enter UDS"
                    value={uds}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setUds(value);
                    }}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Sq.Yards</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>
            )}
          </Grid>

          {/* Contact Information - Moved to Bottom */}
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
              Contact Information <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Owner Name
                  </Typography>
                  <TextField
                    id="ownerName"
                    fullWidth
                    size="small"
                    placeholder="Enter owner name"
                    value={ownerName}
                    onChange={(e) => {
                      setOwnerName(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
                    error={!!errors.ownerName}
                    helperText={errors.ownerName}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Contact Number
                  </Typography>
                  <TextField
                    id="contactNumber"
                    fullWidth
                    size="small"
                    type="tel"
                    placeholder="Enter contact number"
                    value={contactNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === 'N/A' || value === '') {
                        setContactNumber(value);
                      } else {
                        const numericValue = value.replace(/\D/g, '').slice(0, 10);
                        setContactNumber(numericValue);
                        if (numericValue !== 'N/A') {
                          setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
                        }
                      }
                    }}
                    disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
                    error={!!errors.contactNumber}
                    helperText={errors.contactNumber}
                    inputProps={{ maxLength: 10 }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Email Address
                  </Typography>
                  <TextField
                    id="emailAddress"
                    fullWidth
                    size="small"
                    type="email"
                    placeholder="Enter email address"
                    value={emailAddress}
                    onChange={(e) => {
                      setEmailAddress(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
                    error={!!errors.emailAddress}
                    helperText={errors.emailAddress}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </>
      )}

      {/* INDEPENDENT HOUSE FIELDS */}
      {isIndependentHouse && (
        <>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '280px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="socialMediaLink"
                  fullWidth
                  size="small"
                  type="url"
                  placeholder="YouTube, Facebook, WhatsApp, Instagram"
                  value={socialMediaLink}
                  onChange={(e) => {
                    setSocialMediaLink(e.target.value);
                    if (e.target.value) {
                      setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
                    } else {
                      setErrors(prev => ({...prev, socialMediaLink: ''}));
                    }
                  }}
                  error={!!errors.socialMediaLink}
                  helperText={errors.socialMediaLink}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '210px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  BHK <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <FormControl fullWidth size="small" error={!!errors.bhk}>
                  <Select
                    value={selectedBHK}
                    onChange={(e) => {
                      setSelectedBHK(e.target.value);
                      setErrors({...errors, bhk: ''});
                    }}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
                    {bhkOptions.map((option) => (
                      <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                    ))}
                  </Select>
                  {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '210px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <FormControl fullWidth size="small" error={!!errors.furnish}>
                  <Select
                    value={selectedFurnish}
                    onChange={(e) => {
                      setSelectedFurnish(e.target.value);
                      setErrors({...errors, furnish: ''});
                    }}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
                    {furnishTypes.map((type) => (
                      <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
                    ))}
                  </Select>
                  {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
                </FormControl>
              </Box>
            </Grid>
          </Grid>

          {/* Built-up Area and Property Size - NO UDS FIELD */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <TextField
                  id="builtUpArea"
                  fullWidth
                  size="small"
                  placeholder="Enter built-up area"
                  value={builtUpArea}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setBuiltUpArea(value);
                    setErrors(prev => ({...prev, builtUpArea: validateNumber(value, "Built-up area")}));
                  }}
                  error={!!errors.builtUpArea}
                  helperText={errors.builtUpArea}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Property Size <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <TextField
                    id="propertySize"
                    fullWidth
                    size="small"
                    placeholder="Enter size"
                    value={propertySize}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setPropertySize(value);
                      setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
                    }}
                    error={!!errors.propertySize}
                    helperText={errors.propertySize}
                    sx={{ 
                      flex: 1,
                      '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } 
                    }}
                  />
                  <FormControl size="small" sx={{ minWidth: 100 }}>
                    <Select
                      value={selectedUnit}
                      onChange={(e) => setSelectedUnit(e.target.value)}
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="sq.feet">Sq.Ft</MenuItem>
                      <MenuItem value="sq.yards">Sq.Yards</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </Box>
            </Grid>
          </Grid>

          {/* Contact Information - Moved to Bottom */}
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
              Contact Information <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Owner Name
                  </Typography>
                  <TextField
                    id="ownerName"
                    fullWidth
                    size="small"
                    placeholder="Enter owner name"
                    value={ownerName}
                    onChange={(e) => {
                      setOwnerName(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
                    error={!!errors.ownerName}
                    helperText={errors.ownerName}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Contact Number
                  </Typography>
                  <TextField
                    id="contactNumber"
                    fullWidth
                    size="small"
                    type="tel"
                    placeholder="Enter contact number"
                    value={contactNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === 'N/A' || value === '') {
                        setContactNumber(value);
                      } else {
                        const numericValue = value.replace(/\D/g, '').slice(0, 10);
                        setContactNumber(numericValue);
                        if (numericValue !== 'N/A') {
                          setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
                        }
                      }
                    }}
                    disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
                    error={!!errors.contactNumber}
                    helperText={errors.contactNumber}
                    inputProps={{ maxLength: 10 }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Email Address
                  </Typography>
                  <TextField
                    id="emailAddress"
                    fullWidth
                    size="small"
                    type="email"
                    placeholder="Enter email address"
                    value={emailAddress}
                    onChange={(e) => {
                      setEmailAddress(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
                    error={!!errors.emailAddress}
                    helperText={errors.emailAddress}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </>
      )}

      {/* PENT HOUSE FIELDS */}
      {isPentHouse && (
        <>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '280px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="socialMediaLink"
                  fullWidth
                  size="small"
                  type="url"
                  placeholder="YouTube, Facebook, WhatsApp, Instagram"
                  value={socialMediaLink}
                  onChange={(e) => {
                    setSocialMediaLink(e.target.value);
                    if (e.target.value) {
                      setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
                    } else {
                      setErrors(prev => ({...prev, socialMediaLink: ''}));
                    }
                  }}
                  error={!!errors.socialMediaLink}
                  helperText={errors.socialMediaLink}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '210px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  BHK <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <FormControl fullWidth size="small" error={!!errors.bhk}>
                  <Select
                    value={selectedBHK}
                    onChange={(e) => {
                      setSelectedBHK(e.target.value);
                      setErrors({...errors, bhk: ''});
                    }}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
                    {bhkOptions.map((option) => (
                      <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                    ))}
                  </Select>
                  {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '210px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <FormControl fullWidth size="small" error={!!errors.furnish}>
                  <Select
                    value={selectedFurnish}
                    onChange={(e) => {
                      setSelectedFurnish(e.target.value);
                      setErrors({...errors, furnish: ''});
                    }}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
                    {furnishTypes.map((type) => (
                      <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
                    ))}
                  </Select>
                  {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
                </FormControl>
              </Box>
            </Grid>
          </Grid>

          {/* Carpet Area (MANDATORY), Built-up Area (MANDATORY), UDS (Optional, not for rental) */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Carpet Area <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <TextField
                  id="carpetArea"
                  fullWidth
                  size="small"
                  placeholder="Enter carpet area"
                  value={carpetArea}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setCarpetArea(value);
                    setErrors(prev => ({...prev, carpetArea: validateNumber(value, "Carpet area")}));
                  }}
                  error={!!errors.carpetArea}
                  helperText={errors.carpetArea}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <TextField
                  id="builtUpArea"
                  fullWidth
                  size="small"
                  placeholder="Enter built-up area"
                  value={builtUpArea}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setBuiltUpArea(value);
                    setErrors(prev => ({...prev, builtUpArea: validateNumber(value, "Built-up area")}));
                  }}
                  error={!!errors.builtUpArea}
                  helperText={errors.builtUpArea}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            {/* UDS field - Optional and NOT shown for rental properties */}
            {!isRental && (
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    UDS <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                  </Typography>
                  <TextField
                    id="uds"
                    fullWidth
                    size="small"
                    placeholder="Enter UDS"
                    value={uds}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setUds(value);
                    }}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Sq.Yards</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>
            )}
          </Grid>

          {/* Contact Information - Moved to Bottom */}
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
              Contact Information <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Owner Name
                  </Typography>
                  <TextField
                    id="ownerName"
                    fullWidth
                    size="small"
                    placeholder="Enter owner name"
                    value={ownerName}
                    onChange={(e) => {
                      setOwnerName(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
                    error={!!errors.ownerName}
                    helperText={errors.ownerName}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Contact Number
                  </Typography>
                  <TextField
                    id="contactNumber"
                    fullWidth
                    size="small"
                    type="tel"
                    placeholder="Enter contact number"
                    value={contactNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === 'N/A' || value === '') {
                        setContactNumber(value);
                      } else {
                        const numericValue = value.replace(/\D/g, '').slice(0, 10);
                        setContactNumber(numericValue);
                        if (numericValue !== 'N/A') {
                          setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
                        }
                      }
                    }}
                    disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
                    error={!!errors.contactNumber}
                    helperText={errors.contactNumber}
                    inputProps={{ maxLength: 10 }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Email Address
                  </Typography>
                  <TextField
                    id="emailAddress"
                    fullWidth
                    size="small"
                    type="email"
                    placeholder="Enter email address"
                    value={emailAddress}
                    onChange={(e) => {
                      setEmailAddress(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
                    error={!!errors.emailAddress}
                    helperText={errors.emailAddress}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </>
      )}

      {/* STUDIO FIELDS */}
      {isStudio && (
        <>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '280px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="socialMediaLink"
                  fullWidth
                  size="small"
                  type="url"
                  placeholder="YouTube, Facebook, WhatsApp, Instagram"
                  value={socialMediaLink}
                  onChange={(e) => {
                    setSocialMediaLink(e.target.value);
                    if (e.target.value) {
                      setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
                    } else {
                      setErrors(prev => ({...prev, socialMediaLink: ''}));
                    }
                  }}
                  error={!!errors.socialMediaLink}
                  helperText={errors.socialMediaLink}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '210px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  BHK <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <FormControl fullWidth size="small" error={!!errors.bhk}>
                  <Select
                    value={selectedBHK}
                    onChange={(e) => {
                      setSelectedBHK(e.target.value);
                      setErrors({...errors, bhk: ''});
                    }}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
                    {bhkOptions.map((option) => (
                      <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                    ))}
                  </Select>
                  {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '210px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <FormControl fullWidth size="small" error={!!errors.furnish}>
                  <Select
                    value={selectedFurnish}
                    onChange={(e) => {
                      setSelectedFurnish(e.target.value);
                      setErrors({...errors, furnish: ''});
                    }}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
                    {furnishTypes.map((type) => (
                      <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
                    ))}
                  </Select>
                  {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
                </FormControl>
              </Box>
            </Grid>
          </Grid>

          {/* Carpet Area (MANDATORY) and UDS (MANDATORY, not for rental) - NO PROPERTY SIZE */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Carpet Area <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <TextField
                  id="carpetArea"
                  fullWidth
                  size="small"
                  placeholder="Enter carpet area"
                  value={carpetArea}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setCarpetArea(value);
                    setErrors(prev => ({...prev, carpetArea: validateNumber(value, "Carpet area")}));
                  }}
                  error={!!errors.carpetArea}
                  helperText={errors.carpetArea}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            {/* UDS field - MANDATORY for Studio (not shown for rental properties) */}
            {!isRental && (
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    UDS <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <TextField
                    id="uds"
                    fullWidth
                    size="small"
                    placeholder="Enter UDS"
                    value={uds}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setUds(value);
                      setErrors(prev => ({...prev, uds: validateNumber(value, "UDS")}));
                    }}
                    error={!!errors.uds}
                    helperText={errors.uds}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Sq.Yards</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>
            )}
          </Grid>

          {/* Contact Information - Moved to Bottom */}
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
              Contact Information <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Owner Name
                  </Typography>
                  <TextField
                    id="ownerName"
                    fullWidth
                    size="small"
                    placeholder="Enter owner name"
                    value={ownerName}
                    onChange={(e) => {
                      setOwnerName(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
                    error={!!errors.ownerName}
                    helperText={errors.ownerName}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Contact Number
                  </Typography>
                  <TextField
                    id="contactNumber"
                    fullWidth
                    size="small"
                    type="tel"
                    placeholder="Enter contact number"
                    value={contactNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === 'N/A' || value === '') {
                        setContactNumber(value);
                      } else {
                        const numericValue = value.replace(/\D/g, '').slice(0, 10);
                        setContactNumber(numericValue);
                        if (numericValue !== 'N/A') {
                          setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
                        }
                      }
                    }}
                    disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
                    error={!!errors.contactNumber}
                    helperText={errors.contactNumber}
                    inputProps={{ maxLength: 10 }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Email Address
                  </Typography>
                  <TextField
                    id="emailAddress"
                    fullWidth
                    size="small"
                    type="email"
                    placeholder="Enter email address"
                    value={emailAddress}
                    onChange={(e) => {
                      setEmailAddress(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
                    error={!!errors.emailAddress}
                    helperText={errors.emailAddress}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </>
      )}

      {/* VILLA FIELDS */}
      {isVilla && (
        <>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '280px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="socialMediaLink"
                  fullWidth
                  size="small"
                  type="url"
                  placeholder="YouTube, Facebook, WhatsApp, Instagram"
                  value={socialMediaLink}
                  onChange={(e) => {
                    setSocialMediaLink(e.target.value);
                    if (e.target.value) {
                      setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
                    } else {
                      setErrors(prev => ({...prev, socialMediaLink: ''}));
                    }
                  }}
                  error={!!errors.socialMediaLink}
                  helperText={errors.socialMediaLink}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '210px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  BHK <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <FormControl fullWidth size="small" error={!!errors.bhk}>
                  <Select
                    value={selectedBHK}
                    onChange={(e) => {
                      setSelectedBHK(e.target.value);
                      setErrors({...errors, bhk: ''});
                    }}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
                    {bhkOptions.map((option) => (
                      <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                    ))}
                  </Select>
                  {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '210px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <FormControl fullWidth size="small" error={!!errors.furnish}>
                  <Select
                    value={selectedFurnish}
                    onChange={(e) => {
                      setSelectedFurnish(e.target.value);
                      setErrors({...errors, furnish: ''});
                    }}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
                    {furnishTypes.map((type) => (
                      <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
                    ))}
                  </Select>
                  {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
                </FormControl>
              </Box>
            </Grid>
          </Grid>

          {/* Built-up Area and Property Size (with units dropdown) - NO UDS */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <TextField
                  id="builtUpArea"
                  fullWidth
                  size="small"
                  placeholder="Enter built-up area"
                  value={builtUpArea}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setBuiltUpArea(value);
                    setErrors(prev => ({...prev, builtUpArea: validateNumber(value, "Built-up area")}));
                  }}
                  error={!!errors.builtUpArea}
                  helperText={errors.builtUpArea}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Property Size <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <TextField
                    id="propertySize"
                    fullWidth
                    size="small"
                    placeholder="Enter size"
                    value={propertySize}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setPropertySize(value);
                      setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
                    }}
                    error={!!errors.propertySize}
                    helperText={errors.propertySize}
                    sx={{ 
                      flex: 1,
                      '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } 
                    }}
                  />
                  <FormControl size="small" sx={{ minWidth: 100 }}>
                    <Select
                      value={selectedUnit}
                      onChange={(e) => setSelectedUnit(e.target.value)}
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="sq.feet">Sq.Ft</MenuItem>
                      <MenuItem value="sq.yards">Sq.Yards</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </Box>
            </Grid>
          </Grid>

          {/* Contact Information - Moved to Bottom */}
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
              Contact Information <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Owner Name
                  </Typography>
                  <TextField
                    id="ownerName"
                    fullWidth
                    size="small"
                    placeholder="Enter owner name"
                    value={ownerName}
                    onChange={(e) => {
                      setOwnerName(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
                    error={!!errors.ownerName}
                    helperText={errors.ownerName}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Contact Number
                  </Typography>
                  <TextField
                    id="contactNumber"
                    fullWidth
                    size="small"
                    type="tel"
                    placeholder="Enter contact number"
                    value={contactNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === 'N/A' || value === '') {
                        setContactNumber(value);
                      } else {
                        const numericValue = value.replace(/\D/g, '').slice(0, 10);
                        setContactNumber(numericValue);
                        if (numericValue !== 'N/A') {
                          setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
                        }
                      }
                    }}
                    disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
                    error={!!errors.contactNumber}
                    helperText={errors.contactNumber}
                    inputProps={{ maxLength: 10 }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Email Address
                  </Typography>
                  <TextField
                    id="emailAddress"
                    fullWidth
                    size="small"
                    type="email"
                    placeholder="Enter email address"
                    value={emailAddress}
                    onChange={(e) => {
                      setEmailAddress(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
                    error={!!errors.emailAddress}
                    helperText={errors.emailAddress}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </>
      )}

      {/* PLOT & AGRICULTURE LAND FIELDS */}
      {(isPlot || isAgricultureLand) && (
        <>
          {/* Social Media Link */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '410px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="socialMediaLink"
                  fullWidth
                  size="small"
                  type="url"
                  placeholder="YouTube, Facebook, WhatsApp, Instagram"
                  value={socialMediaLink}
                  onChange={(e) => {
                    setSocialMediaLink(e.target.value);
                    if (e.target.value) {
                      setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
                    } else {
                      setErrors(prev => ({...prev, socialMediaLink: ''}));
                    }
                  }}
                  error={!!errors.socialMediaLink}
                  helperText={errors.socialMediaLink}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Property Size with Units*Dropdown, Zone Type, Ownership */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Property Size <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <TextField
                    id="propertySize"
                    fullWidth
                    size="small"
                    placeholder="Enter size"
                    value={propertySize}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setPropertySize(value);
                      setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
                    }}
                    error={!!errors.propertySize}
                    helperText={errors.propertySize}
                    sx={{ 
                      flex: 1,
                      '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } 
                    }}
                  />
                  <FormControl size="small" sx={{ minWidth: 100 }}>
                    <Select
                      value={selectedUnit}
                      onChange={(e) => setSelectedUnit(e.target.value)}
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="sq.feet">Sq.Ft</MenuItem>
                      <MenuItem value="sq.yards">Sq.Yards</MenuItem>
                      {isAgricultureLand && <MenuItem value="acres">Acres</MenuItem>}
                    </Select>
                  </FormControl>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="zoneType"
                  fullWidth
                  size="small"
                  placeholder="Enter zone type"
                  value={zoneType}
                  onChange={(e) => setZoneType(e.target.value)}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Ownership <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <FormControl fullWidth size="small">
                  <Select
                    value={selectedOwnership}
                    onChange={(e) => setSelectedOwnership(e.target.value)}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value=""><em>Select Ownership</em></MenuItem>
                    {ownerships.map((own) => (
                      <MenuItem key={own} value={own}>{own}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Grid>
          </Grid>

          {/* Length and Width (only for Plot, NOT for Agriculture Land) - Units changed to Feet */}
          {isPlot && (
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Length <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                  </Typography>
                  <TextField
                    id="propertyLength"
                    fullWidth
                    size="small"
                    placeholder="Enter length"
                    value={propertyLength}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setPropertyLength(value);
                    }}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Feet</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Width <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                  </Typography>
                  <TextField
                    id="propertyWidth"
                    fullWidth
                    size="small"
                    placeholder="Enter width"
                    value={propertyWidth}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setPropertyWidth(value);
                    }}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Feet</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>
            </Grid>
          )}

          {/* Contact Information - Moved to Bottom */}
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
              Contact Information <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Owner Name
                  </Typography>
                  <TextField
                    id="ownerName"
                    fullWidth
                    size="small"
                    placeholder="Enter owner name"
                    value={ownerName}
                    onChange={(e) => {
                      setOwnerName(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
                    error={!!errors.ownerName}
                    helperText={errors.ownerName}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Contact Number
                  </Typography>
                  <TextField
                    id="contactNumber"
                    fullWidth
                    size="small"
                    type="tel"
                    placeholder="Enter contact number"
                    value={contactNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === 'N/A' || value === '') {
                        setContactNumber(value);
                      } else {
                        const numericValue = value.replace(/\D/g, '').slice(0, 10);
                        setContactNumber(numericValue);
                        if (numericValue !== 'N/A') {
                          setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
                        }
                      }
                    }}
                    disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
                    error={!!errors.contactNumber}
                    helperText={errors.contactNumber}
                    inputProps={{ maxLength: 10 }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Email Address
                  </Typography>
                  <TextField
                    id="emailAddress"
                    fullWidth
                    size="small"
                    type="email"
                    placeholder="Enter email address"
                    value={emailAddress}
                    onChange={(e) => {
                      setEmailAddress(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
                    error={!!errors.emailAddress}
                    helperText={errors.emailAddress}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </>
      )}

      {/* FARMHOUSE FIELDS */}
      {isFarmhouse && (
        <>
          {/* Social Media Link, BHK, Furnish Type */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '300px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="socialMediaLink"
                  fullWidth
                  size="small"
                  type="url"
                  placeholder="YouTube, Facebook, WhatsApp, Instagram"
                  value={socialMediaLink}
                  onChange={(e) => {
                    setSocialMediaLink(e.target.value);
                    if (e.target.value) {
                      setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
                    } else {
                      setErrors(prev => ({...prev, socialMediaLink: ''}));
                    }
                  }}
                  error={!!errors.socialMediaLink}
                  helperText={errors.socialMediaLink}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '180px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  BHK <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <FormControl fullWidth size="small" error={!!errors.bhk}>
                  <Select
                    value={selectedBHK}
                    onChange={(e) => {
                      setSelectedBHK(e.target.value);
                      setErrors({...errors, bhk: ''});
                    }}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
                    {bhkOptions.map((option) => (
                      <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                    ))}
                  </Select>
                  {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '230px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <FormControl fullWidth size="small" error={!!errors.furnish}>
                  <Select
                    value={selectedFurnish}
                    onChange={(e) => {
                      setSelectedFurnish(e.target.value);
                      setErrors({...errors, furnish: ''});
                    }}
                    displayEmpty
                    sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  >
                    <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
                    {furnishTypes.map((type) => (
                      <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
                    ))}
                  </Select>
                  {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
                </FormControl>
              </Box>
            </Grid>
          </Grid>

          {/* Built-up Area (MANDATORY), Carpet Area (OPTIONAL), and Property Size with Units Dropdown */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <TextField
                  id="builtUpArea"
                  fullWidth
                  size="small"
                  placeholder="Enter built-up area"
                  value={builtUpArea}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setBuiltUpArea(value);
                    setErrors(prev => ({...prev, builtUpArea: validateNumber(value, "Built-up area")}));
                  }}
                  error={!!errors.builtUpArea}
                  helperText={errors.builtUpArea}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Carpet Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                </Typography>
                <TextField
                  id="carpetArea"
                  fullWidth
                  size="small"
                  placeholder="Enter carpet area"
                  value={carpetArea}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    setCarpetArea(value);
                  }}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                  }}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Box sx={{ width: '270px', maxWidth: '100%' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                  Property Size <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <TextField
                    id="propertySize"
                    fullWidth
                    size="small"
                    placeholder="Enter size"
                    value={propertySize}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setPropertySize(value);
                      setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
                    }}
                    error={!!errors.propertySize}
                    helperText={errors.propertySize}
                    sx={{ 
                      flex: 1,
                      '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } 
                    }}
                  />
                  <FormControl size="small" sx={{ minWidth: 100 }}>
                    <Select
                      value={selectedUnit}
                      onChange={(e) => setSelectedUnit(e.target.value)}
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="sq.feet">Sq.Ft</MenuItem>
                      <MenuItem value="sq.yards">Sq.Yards</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </Box>
            </Grid>
          </Grid>

          {/* Contact Information - Moved to Bottom */}
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
              Contact Information <span style={{ color: '#d32f2f' }}>*</span>
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Owner Name
                  </Typography>
                  <TextField
                    id="ownerName"
                    fullWidth
                    size="small"
                    placeholder="Enter owner name"
                    value={ownerName}
                    onChange={(e) => {
                      setOwnerName(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
                    error={!!errors.ownerName}
                    helperText={errors.ownerName}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Contact Number
                  </Typography>
                  <TextField
                    id="contactNumber"
                    fullWidth
                    size="small"
                    type="tel"
                    placeholder="Enter contact number"
                    value={contactNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === 'N/A' || value === '') {
                        setContactNumber(value);
                      } else {
                        const numericValue = value.replace(/\D/g, '').slice(0, 10);
                        setContactNumber(numericValue);
                        if (numericValue !== 'N/A') {
                          setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
                        }
                      }
                    }}
                    disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
                    error={!!errors.contactNumber}
                    helperText={errors.contactNumber}
                    inputProps={{ maxLength: 10 }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                    Email Address
                  </Typography>
                  <TextField
                    id="emailAddress"
                    fullWidth
                    size="small"
                    type="email"
                    placeholder="Enter email address"
                    value={emailAddress}
                    onChange={(e) => {
                      setEmailAddress(e.target.value);
                      if (e.target.value !== 'N/A') {
                        setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
                      }
                    }}
                    disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
                    error={!!errors.emailAddress}
                    helperText={errors.emailAddress}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                        backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
                      }
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </>
      )}

      {/* Image Preview Dialog */}
      {imagePreviews.length > 0 && (
        <Dialog
          open={previewOpen}
          onClose={() => setPreviewOpen(false)}
          maxWidth="md"
          fullWidth
          sx={{ '& .MuiDialog-paper': { borderRadius: '12px', overflow: 'hidden', bgcolor: 'black' } }}
        >
          <DialogContent sx={{ p: 0, position: 'relative' }}>
            <Box
              component="img"
              src={imagePreviews[selectedImageIndex]}
              alt={`Image ${selectedImageIndex + 1}`}
              sx={{ width: '100%', height: 'auto', maxHeight: '80vh', objectFit: 'contain' }}
            />
            <IconButton
              onClick={() => setPreviewOpen(false)}
              sx={{
                position: 'absolute',
                top: 8,
                right: 8,
                bgcolor: 'rgba(255, 255, 255, 0.3)',
                color: 'white',
                '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
              }}
            >
              <CloseIcon />
            </IconButton>
            {imagePreviews.length > 1 && (
              <>
                <IconButton
                  onClick={() => setSelectedImageIndex(prev => (prev > 0 ? prev - 1 : imagePreviews.length - 1))}
                  sx={{
                    position: 'absolute',
                    left: 8,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    bgcolor: 'rgba(255, 255, 255, 0.3)',
                    color: 'white',
                    '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
                  }}
                >
                  ‹
                </IconButton>
                <IconButton
                  onClick={() => setSelectedImageIndex(prev => (prev < imagePreviews.length - 1 ? prev + 1 : 0))}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    bgcolor: 'rgba(255, 255, 255, 0.3)',
                    color: 'white',
                    '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
                  }}
                >
                  ›
                </IconButton>
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 16,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    bgcolor: 'rgba(0, 0, 0, 0.7)',
                    color: 'white',
                    px: 2,
                    py: 1,
                    borderRadius: '16px',
                    fontSize: '14px',
                    fontFamily: 'Outfit'
                  }}
                >
                  {selectedImageIndex + 1} / {imagePreviews.length}
                </Box>
              </>
            )}
          </DialogContent>
        </Dialog>
      )}
    </Box>
  );
};

export default PropertyResidential;



